import { useState } from "react"

import type { Product } from "@/graphql/codegen/graphql"
import type { PricingDialogs } from "@/screens/Pricing/constants"

interface UsePricingModalReturn {
  isDialogOpen: PricingDialogs | null
  selectedProduct: Product | null
  setSelectedProduct: (product: Product | null) => void
  setIsDialogOpen: (dialog: PricingDialogs | null) => void
}

export const usePricingDialog = (): UsePricingModalReturn => {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null)
  const [isDialogOpen, setIsDialogOpen] = useState<PricingDialogs | null>(null)

  return {
    selectedProduct,
    isDialogOpen,
    setSelectedProduct,
    setIsDialogOpen,
  }
}
